import { render, staticRenderFns } from "./PasswordExpiryBanner.vue?vue&type=template&id=5a831bc0&scoped=true&"
import script from "./PasswordExpiryBanner.vue?vue&type=script&lang=js&"
export * from "./PasswordExpiryBanner.vue?vue&type=script&lang=js&"
import style0 from "./PasswordExpiryBanner.vue?vue&type=style&index=0&id=5a831bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a831bc0",
  null
  
)

export default component.exports